import { lazyLoad } from '~/src/shared/utils/loadable';

export const MunicipalityCollaborationFukushimaPage = lazyLoad(
  () => import('./index'),
  (module) => module.MunicipalityCollaborationFukushima,
);
